'use client';
import Link from '@/components/LocaleLink';
import Image from 'next/image';
import { memo } from 'react';
import customImageLoader from '@/components/CustomImage';
import { useTranslation } from '@/contexts/TranslationContext';

const isValidUrl = (url) => {
  try {
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
};

const ArticleCard = memo(
  ({ article }) => {
    const { t } = useTranslation();
    const bannerImage = isValidUrl(article.bannerImage) ? article.bannerImage : '/assets/images/boys-nettleworth.webp';

    return (
      <Link href={`/info/${article.slug}`} prefetch={false}>
        <div className="article-card">
          <div className="image-container">
            <Image
              priority
              loader={customImageLoader}
              src={bannerImage}
              alt={t('aria.bannerImage')}
              width={300}
              height={200}
            />
          </div>
          <div className="text-box">
            <p>{article.description}</p>
            <span># {article.slug}</span>
          </div>
        </div>
      </Link>
    );
  },
  (prevProps, nextProps) => prevProps.article.id === nextProps.article.id,
);

export default ArticleCard;
